module.exports = __webpack_public_path__ + "static/prime_concept-d8f55906a573b9044afa81bc47fcb019.png";